export default class y {
  constructor() {}
  Rs(a) {}
  changeUser(a) {}
  clearData() {}
}
